import { TransitOperationInfoResponse, UpdateReviewRequest } from '../../../../../api/models'
import { UserFeedbackRequest } from '../../../../../api/models/user-feedback-request'
import { TransitOperationInfo } from './types'

export function fromTransitOperationInfoResponse(response: TransitOperationInfoResponse): TransitOperationInfo {
  return {
    id: response.id ?? null,
    dateReviewed: response.dateReviewed,
    isReviewed: response.isReviewed,
    feedback: response.feedback,
    notes: response.notes,
    reviewedBy: response.reviewedBy,
  }
}

export type UserFeedbackRequestWithCancellationReason = UserFeedbackRequest & { cancellationReason?: string }

export function toFeedbackRequest(
  feedback: string,
  isDeclarationDeclined: boolean,
  isPdfIncluded: boolean,
  emails: Array<string>,
  blindCopyEmail: string,
  cancellationReason?: string,
): UserFeedbackRequestWithCancellationReason {
  return {
    feedback,
    isDeclarationDeclined,
    isPdfIncluded,
    emails,
    blindCopyEmail,
    cancellationReason,
  }
}

export function toUpdateReviewRequest(isReviewed: boolean): UpdateReviewRequest {
  return {
    isReviewed,
  }
}
